export default __webpack_public_path__ + "static/media/predictionbg.5ea89bca.png";